import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface BuildingPermitFeesProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const BuildingPermitFees: React.FC<BuildingPermitFeesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [buildingPermitFees, set_buildingPermitFees] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Building Permit Fees']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Building Permit Fees': [b.values?.['Site Work']?.['Building Permit Fees']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Building Permit Fees';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(buildingPermitFees)}
                />
            ) : (
                <MoneyBox
                    id={'buildingPermitFees'}
                    allowNegative={false}
                    value={buildingPermitFees}
                    onChange={(value) => set_buildingPermitFees(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
